module.exports = __webpack_public_path__ + "static/seo-partnership-aaa60fb6f7c892cc977dc2c1535941e7.png";